import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { DateTime } from 'luxon';

import { BorderDirectionStoreModelEnum } from '@domain/common';
import {
  BypassRemitRequestStoreModel,
  CrisisFilesStoreModel,
  CrisisOutageDetailsStoreModel,
  CurtailmentAffectedTimescaleStoreModel,
  ExecuteCurtailmentRequestStoreModel,
  GetCurtailmentResponseMtusStoreModel,
  PostCrisisMessageRequestStoreModel,
} from '@domain/crisis-management';
import { MessageStoreModel } from '@domain/messages';

export const CrisisActions = createActionGroup({
  source: 'CRISIS',
  events: {
    'Clear crisis': emptyProps(),

    'Check crisis': emptyProps(),
    'Check crisis success': emptyProps(),
    'Check crisis fail': emptyProps(),

    'Get outage details': props<{
      isPolling: boolean;
    }>(),
    'Get outage details success': props<{ outageDetails: CrisisOutageDetailsStoreModel }>(),
    'Get outage details fail': props<{ errorMsg: string }>(),

    'Get crisis curtailment': props<{ deliveryDayDateTime: DateTime; isPolling: boolean }>(),
    'Get crisis curtailment success': props<{
      mtus: GetCurtailmentResponseMtusStoreModel[];
      affectedTimescales: CurtailmentAffectedTimescaleStoreModel;
    }>(),
    'Get crisis curtailment fail': props<{ errorMsg: string }>(),

    'Execute crisis curtailment': props<{ deliveryDayDateTime: DateTime; request: ExecuteCurtailmentRequestStoreModel }>(),
    'Execute crisis curtailment success': props<{ deliveryDayDateTime: DateTime }>(),
    'Execute crisis curtailment fail': props<{ errorCode: string; errorMsg: string }>(),

    'End unplanned outage': props<{ id: string }>(),
    'End unplanned outage success': emptyProps(),
    'End unplanned outage fail': props<{ errorMsg: string }>(),

    'Resend remit': props<{ direction: BorderDirectionStoreModelEnum }>(),
    'Resend remit success': emptyProps(),
    'Resend remit fail': props<{ errorMsg: string }>(),

    'Bypass remit': props<{ direction: BorderDirectionStoreModelEnum; request: BypassRemitRequestStoreModel }>(),
    'Bypass remit success': emptyProps(),
    'Bypass remit fail': emptyProps(),

    'Get crisis messages': props<{
      isPolling: boolean;
    }>(),
    'Get crisis messages success': props<{ messages: MessageStoreModel[] }>(),
    'Get crisis messages fail': props<{ errorMsg: string }>(),

    'Post crisis message': props<{ message: PostCrisisMessageRequestStoreModel }>(),
    'Post crisis message success': emptyProps(),
    'Post crisis message fail': props<{ errorCode: string; errorMsg: string }>(),

    'Get crisis files': props<{
      isPolling: boolean;
    }>(),
    'Get crisis files success': props<{ crisisFiles: CrisisFilesStoreModel }>(),
    'Get crisis files fail': props<{ errorMsg: string }>(),

    'No crisis refresh necessary': emptyProps(),
    'No previous request data found': emptyProps(),
  },
});
